import { Component } from "@angular/core";

@Component({
  selector: "icon-ajuste-pension-trending-down",
  templateUrl: "./ajuste-pension-trending-down.svg",
  standalone: true,
})
export class AjustePensionTrendingDownComponent {}